import { RootState } from "types";
import { initialState } from "./initialState";
import { createSelector } from "@reduxjs/toolkit";

// Select domain from the state
const selectDomain = (state: RootState) => state?.timeZoneState || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading
);

export const selectList = createSelector([selectDomain], (state) => state.list);
export const selectPagination = createSelector(
  [selectDomain],
  (state) => state.pagination
);
export const selectHasMore = createSelector(
  [selectPagination],
 (pagination) => {
    if (!pagination) return false;
    return pagination.page < pagination.totalPage;
  },
);
